import axios from 'axios';
import { apiAddress } from '../../config';

/**
 * Get track metadata and audio URL
 * @param {string} trackId - Track UUID
 * @returns {Promise} Track data with presigned S3 URL
 */
export const getTrack = async (trackId) => {
  const response = await axios.get(`${apiAddress}/audio/tracks/${trackId}`);
  return response.data;
};

/**
 * Start playback tracking (creates playback_event)
 * @param {string} trackId - Track UUID
 * @returns {Promise} Playback event ID for heartbeats
 */
export const startPlayback = async (trackId) => {
  const response = await axios.post(`${apiAddress}/audio/tracks/${trackId}/play`, {
    platform: 'web',
  });
  return response.data;
};

/**
 * Send playback heartbeat (every 10 seconds)
 * @param {number} eventId - Playback event ID
 * @param {number} secondsListened - Cumulative seconds listened
 * @returns {Promise}
 */
export const sendHeartbeat = async (eventId, secondsListened) => {
  const response = await axios.post(
    `${apiAddress}/audio/playback/${eventId}/heartbeat`,
    {
      seconds_listened: secondsListened,
    }
  );
  return response.data;
};

/**
 * Get all tracks for a tour
 * @param {string} tourId - Tour UUID
 * @returns {Promise} Array of tracks
 */
export const getTourTracks = async (tourId) => {
  const response = await axios.get(`${apiAddress}/audio/tours/${tourId}/tracks`);
  return response.data;
};
